<h1 class="text-white text-lg font-semibold mb-4">Liquidaciones</h1>

<div class="mb-4 flex justify-between items-center">
    <div></div>
    <mat-form-field class="ml-4 border-0">
        <input matInput (input)="applyFilter($event)" placeholder="Buscar...">
    </mat-form-field>
</div>

<div *ngIf="dataSource.data.length === 0" class="text-center py-8 text-gray-500">
    <p>No hay liquidaciones registradas.</p>
</div>

<div class="mat-elevation-z2" *ngIf="dataSource.data.length > 0">
    <table mat-table [dataSource]="dataSource" matSort class="w-full">

        <ng-container matColumnDef="week">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Semana </th>
            <td mat-cell *matCellDef="let liq"> {{ liq.week }} </td>
        </ng-container>

        <ng-container matColumnDef="year">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Año </th>
            <td mat-cell *matCellDef="let liq"> {{ liq.year }} </td>
        </ng-container>

        <ng-container matColumnDef="month">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Mes </th>
            <td mat-cell *matCellDef="let liq"> {{ liq.month }} </td>
        </ng-container>

        <ng-container matColumnDef="totalToInvoice">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Total a facturar </th>
            <td mat-cell *matCellDef="let liq"> Q {{ liq.totalToInvoice | number:'1.2-2' }} </td>
        </ng-container>

        <ng-container matColumnDef="totalToDeposit">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Total a depositar </th>
            <td mat-cell *matCellDef="let liq"> Q {{ liq.totalToDeposit | number:'1.2-2' }} </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado </th>
            <td mat-cell *matCellDef="let liq"> {{ getTranslatedStatus(liq.status) }} </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Creado </th>
            <td mat-cell *matCellDef="let liq"> {{ liq.createdAt | date:'dd-MM-yyyy, hh:mm:ss a' }} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Acciones </th>
            <td mat-cell *matCellDef="let liq">
                <button mat-icon-button color="accent" (click)="goToDetail(liq)" aria-label="Ver detalle">
                    <mat-icon fontIcon="open_in_new"></mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
</div>
